import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import api from '../../lib/api';
import { errorMessage } from './prospectionApi';

const fields = { nom: 'Nom / organisation', type: 'Activité', ville: 'Ville', email: 'E-mail professionnel public', site: 'Site officiel', source: 'Page source de l’e-mail', preuve: 'Preuve publiée (citation et contexte)', pertinence: 'Pourquoi ce prospect ?' };
export const ProspectCreate = ({ onCreated, onClose }) => {
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async e => {
    e.preventDefault(); setBusy(true); setError('');
    try {
      const { data } = await api.post('/admin/prospection', values);
      if (data.doublons) { setError('Cette adresse est déjà dans votre liste. Son statut est conservé.'); return; }
      await onCreated(); onClose();
    } catch (err) { setError(errorMessage(err)); } finally { setBusy(false); }
  };
  return <form onSubmit={submit} className="prospect-create" data-testid="prospect-create-form">
    <h2>Ajouter un contact public</h2>
    <div className="prospect-create-fields">{Object.entries(fields).map(([key, label]) => <label key={key} htmlFor={`new-${key}`}>
      {label}{['preuve','pertinence'].includes(key)
        ? <Textarea id={`new-${key}`} data-testid={`prospect-new-${key}`} required minLength={10} maxLength={2000} onChange={e => setValues({ ...values, [key]: e.target.value })}/>
        : <Input id={`new-${key}`} data-testid={`prospect-new-${key}`} required type={key === 'email' ? 'email' : ['site','source'].includes(key) ? 'url' : 'text'} maxLength={key === 'nom' ? 180 : 300} onChange={e => setValues({ ...values, [key]: e.target.value })}/>}
    </label>)}</div>
    {error && <p role="alert" data-testid="prospect-create-error">{error}</p>}
    <div className="prospect-actions"><Button disabled={busy} type="submit" data-testid="prospect-create-submit">{busy ? 'Enregistrement…' : 'Ajouter le prospect'}</Button><Button type="button" variant="outline" onClick={onClose} disabled={busy} data-testid="prospect-create-cancel">Annuler</Button></div>
  </form>;
};